import React, {useState} from 'react';
import {
  IconCalendar,
  // IconCheck,
  // IconChevronLeft,
  // IconChevronRight,
  // IconSpinner,
} from "../../../../../components/icons";
import {useFormik} from "formik";
import {Enlevement} from "../../../../../components/models";
import {toast} from "react-toastify";
import {useParams} from "react-router-dom";
import {createEnlevement, updateEnlevement} from "../../../../../components/requests";
import {useAuth} from "../../../../contexts/AuthContext";

interface EnlevementProps {
  dateOuvertureDossier?: string;
  delaiEnlevement?: string;
  dateEnlevementEffective?: string;
  dateEntree?: string;
  localisation?: string;
}

type EnlevementErrors = Partial<Record<keyof EnlevementProps, string>>;

const validate = (values: EnlevementProps): EnlevementErrors => {
  const errors: EnlevementErrors = {};

  if (!values.dateOuvertureDossier) {
    errors.dateOuvertureDossier = 'Ce champ est requis';
  }
  if (!values.delaiEnlevement) {
    errors.delaiEnlevement = 'Ce champ est requis';
  }
  if (!values.dateEntree) {
    errors.dateEntree = 'Ce champ est requis';
  }

  return errors;
};

const EnlevementForm = (
  {
    enlevement = null,
    setEnlevement = null,
    // setIsActive = null
  }: {
    enlevement?: Enlevement | null,
    setEnlevement?: any | null,
    // setIsActive?: any | null,
  }) => {

  const {canView} = useAuth();

  const {id} = useParams();
  const [enlevementId, setEnlevementId] = useState<number | null>(null);
  // const [isValideLoading, setIsValideLoading] = useState<boolean>(false);
  // const [isBrouillonLoading, setIsBrouillonLoading] = useState<boolean>(false);
  // const [isBrouillon, setIsBrouillon] = useState<boolean | null>(null);

  const formik = useFormik({
    initialValues: {
      dateOuvertureDossier: enlevement ? enlevement.dateOuvertureDossier?.split('T')[0] : '',
      delaiEnlevement: enlevement ? enlevement.delaiEnlevement?.split('T')[0] : '',
      dateEnlevementEffective: enlevement ? enlevement.dateEnlevementEffective?.split('T')[0] : '',
      dateEntree: enlevement ? enlevement.dateEntree?.split('T')[0] : '',
      localisation: enlevement ? enlevement.localisation : '',
    },
    enableReinitialize: true,
    validate,
    onSubmit: (values: EnlevementProps) => {
      // if (isBrouillon) setIsBrouillonLoading(true)
      // else setIsValideLoading(true);

      let payload = {
        dateOuvertureDossier: values.dateOuvertureDossier,
        delaiEnlevement: values.delaiEnlevement,
        dateEnlevementEffective: values.dateEnlevementEffective,
        dateEntree: values.dateEntree,
        localisation: values.localisation,
        // brouillon: isBrouillon,
        ...((!enlevement) ? {dossier: `api/dossiers/${id}`} : {})
      };

      const method = (!enlevement) ? createEnlevement(payload) : updateEnlevement((enlevement.id) ? enlevement.id : enlevementId, payload)
      method
        .then((response) => {
          if ((response.status === 200 || response.status === 201) && response.data !== undefined) {
            setEnlevement({
              ...((!enlevement) ? {} : {id: enlevement.id}),
              dateOuvertureDossier: payload.dateOuvertureDossier,
              delaiEnlevement: payload.delaiEnlevement,
              dateEnlevementEffective: payload.dateEnlevementEffective,
              dateEntree: payload.dateEntree,
              localisation: payload.localisation,
              // brouillon: payload.brouillon,
            })
            if (!enlevement) setEnlevementId(response.data['@id'].split('/').pop())
            toast.success(`Enlèvement ${(!enlevement) ? 'créé' : 'modifié'}`);
          }
        })
        .catch((error) => console.error(error))
        .finally(() => {
          // if (isBrouillon) setIsBrouillonLoading(false)
          // else setIsValideLoading(false);
        })
    },
  });

  return (
    <>
      {/*<form onSubmit={formik.handleSubmit}>*/}
      <div className="p-4 animate-in fade-in duration-300">
        <div className="grid grid-cols-2 gap-4">
          {canView('Enlèvement') && (
            <div className="section-card">
              <div className="section-header">
                <div className="section-icon bg-blue-100 text-blue-600">
                  <IconCalendar/>
                </div>
                <span className="section-title">Enlèvement</span>
              </div>
              <div className="section-body grid grid-cols-2 gap-3">
                <div className="col-span-2">
                  <label className="form-label">Date de création</label>
                  <input
                    name="dateOuvertureDossier"
                    type={formik.values.dateOuvertureDossier ? "date" : "text"}
                    className="form-input hover:cursor-not-allowed"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.dateOuvertureDossier}
                    disabled={true}
                    readOnly={true}
                  />
                  {formik.errors.dateOuvertureDossier ? <div className="text-xs text-red-600">
                    {formik.errors.dateOuvertureDossier}
                  </div> : null}
                </div>
                <div className="col-span-2">
                  <label className="form-label">Date d'enlèvement maximum</label>
                  <input
                    name="delaiEnlevement"
                    type={formik.values.delaiEnlevement ? "date" : "text"}
                    className="form-input hover:cursor-not-allowed"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.delaiEnlevement}
                    disabled={true}
                    readOnly={true}
                  />
                  {formik.errors.delaiEnlevement ? <div className="text-xs text-red-600">
                    {formik.errors.delaiEnlevement}
                  </div> : null}
                </div>
                <div className="col-span-2">
                  <label className="form-label">Date enlèvement effective</label>
                  <input
                    name="dateEnlevementEffective"
                    type={formik.values.dateEnlevementEffective ? "date" : "text"}
                    className="form-input hover:cursor-not-allowed"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.dateEnlevementEffective}
                    disabled={true}
                    readOnly={true}
                  />
                  {formik.errors.dateEnlevementEffective ? <div className="text-xs text-red-600">
                    {formik.errors.dateEnlevementEffective}
                  </div> : null}
                </div>
              </div>
            </div>
          )}
          {canView('Entrée') && (
            <div className="section-card">
              <div className="section-header">
                <div className="section-icon bg-purple-100 text-purple-600">
                  <IconCalendar/>
                </div>
                <span className="section-title">Entrée</span>
              </div>
              <div className="section-body grid grid-cols-2 gap-3">
                <div className="col-span-2">
                  <label className="form-label">Date d'entrée</label>
                  <input
                    name="dateEntree"
                    type={formik.values.dateEntree ? "date" : "text"}
                    className="form-input hover:cursor-not-allowed"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.dateEntree}
                    disabled={true}
                    readOnly={true}
                  />
                  {formik.errors.dateEntree ? <div className="text-xs text-red-600">
                    {formik.errors.dateEntree}
                  </div> : null}
                </div>
                <div className="col-span-2">
                  <label className="form-label">Localisation de stockage</label>
                  <input
                    name="localisation"
                    type="text"
                    className="form-input hover:cursor-not-allowed"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.localisation}
                    disabled={true}
                    readOnly={true}
                  />
                  {formik.errors.localisation ? <div className="text-xs text-red-600">
                    {formik.errors.localisation}
                  </div> : null}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      {/*<div className="fixed bottom-0 left-60 right-0 bg-white border-t border-gray-200 py-3 px-4 z-30">*/}
      {/*  <div className="max-w-[1600px] mx-auto flex items-center justify-between">*/}
      {/*    <div className="flex items-center gap-3">*/}
      {/*      <span*/}
      {/*        onClick={() => setIsActive('depositaire')}*/}
      {/*        className="px-3 py-1.5 text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        <IconChevronLeft className="w-4 h-4"/>*/}
      {/*        Précédent*/}
      {/*      </span>*/}
      {/*      <span*/}
      {/*        onClick={() => setIsActive('frais')}*/}
      {/*        className="px-3 py-1.5 text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        Suivant*/}
      {/*        <IconChevronRight className="w-4 h-4"/>*/}
      {/*      </span>*/}
      {/*    </div>*/}
      {/*    <div className="flex items-center gap-2">*/}
      {/*      <span*/}
      {/*        onClick={() => formik.resetForm()}*/}
      {/*        className="px-3 py-1.5 border border-gray-300 rounded-lg text-gray-700 text-sm font-medium hover:bg-gray-50 hover:cursor-pointer"*/}
      {/*      >*/}
      {/*        Annuler*/}
      {/*      </span>*/}
      {/*      <button*/}
      {/*        type="submit"*/}
      {/*        onClick={() => setIsBrouillon(true)}*/}
      {/*        className="px-3 py-1.5 bg-gray-800 text-white rounded-lg text-sm font-medium hover:bg-gray-900 flex items-center gap-1.5"*/}
      {/*      >*/}
      {/*        {(isBrouillonLoading) && <IconSpinner className="animate-spin w-4 h-4"/>}*/}
      {/*        {(isBrouillonLoading) ? 'Enregistrement' : 'Brouillon'}*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        type="submit"*/}
      {/*        onClick={() => setIsBrouillon(false)}*/}
      {/*        className="px-4 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 flex items-center gap-1.5"*/}
      {/*      >*/}
      {/*        {(isValideLoading) ? <IconSpinner className="animate-spin w-4 h-4"/> : <IconCheck className="w-4 h-4"/>}*/}
      {/*        {(isValideLoading) ? 'Enregistrement' : 'Valider'}*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*</form>*/}
    </>
  );
}

export default EnlevementForm;